import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './maryland-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-maryland',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    TruncateModule,
    TooltipModule,
  ],
  templateUrl: './maryland.component.html',
  styleUrl: './maryland.component.scss',
})
export class MarylandComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('maryland', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('maryland', null);
    }
  }

  onSelect(selectionId: string, formControlName: string): void {
    if (selectionId === 'IndividualState_Split') {
      if (formControlName === 'UMBI_SplitLimits_DropDown') {
        if (this.reactiveForm.get('UMBI_SplitLimits_DropDown').valid) {
          this.reactiveForm
            .get('levelTwo_Radio')
            .setValue('LimitsUMBIUMPD_LevelTwo_Radio', { emitEvent: false });
        }
      }
    }
    if (selectionId === 'IndividualState_CombinedSingleLimit') {
      if (formControlName === 'UMBI_UMPD_CombinedSingleLimit_DropDown') {
        if (
          this.reactiveForm.get('UMBI_UMPD_CombinedSingleLimit_DropDown').valid
        ) {
          this.reactiveForm
            .get('levelTwo_Radio')
            .setValue('LimitsUMBIUMPD_LevelTwo_Radio', { emitEvent: false });
        }
      }
    }
  }
}
